export default "__VITE_ASSET__CVXhXT38__"